import { render, staticRenderFns } from "./ContentBlockRichText.vue?vue&type=template&id=3088689a&"
import script from "./ContentBlockRichText.vue?vue&type=script&lang=js&"
export * from "./ContentBlockRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports